"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class MovieInfo extends React.Component {
    constructor() {
        super(...arguments);
        this.createMarkup = (description) => {
            return { __html: description };
        };
    }
    render() {
        const { title, movie } = this.props;
        const image = movie.image || this.props.imagePlaceholder;
        return (React.createElement("div", { className: "MovieInfo" },
            React.createElement("h1", { className: "title" }, movie.object === 'culture' ? 'Om arrangementet' : 'Om filmen'),
            this.renderAboutMovie(image, movie)));
    }
    convertLengthFormat(length) {
        const minutes = Number(length);
        if (isNaN(minutes)) {
            return length;
        }
        return Math.floor(minutes / 60) + 't ' + minutes % 60 + 'min';
    }
    renderAboutMovie(image, movie) {
        return (React.createElement("div", { className: "about-movie" },
            image && React.createElement("i", { className: "movie-poster", style: { backgroundImage: `url("${image}")` } }),
            movie.object !== 'culture' && (React.createElement("div", { className: "movie-details" },
                movie.originalTitle &&
                    React.createElement("p", null,
                        React.createElement("strong", null, "Originaltittel:"),
                        "\u00A0",
                        movie.originalTitle),
                !movie.originalTitle && movie.title &&
                    React.createElement("p", null,
                        React.createElement("strong", null, "Tittel:"),
                        "\u00A0",
                        movie.title),
                movie.premiere &&
                    React.createElement("p", null,
                        React.createElement("strong", null, "Premiere:"),
                        "\u00A0",
                        movie.premiere),
                movie.runTime &&
                    React.createElement("p", null,
                        React.createElement("strong", null, "Varighet:"),
                        "\u00A0",
                        this.convertLengthFormat(movie.runTime)),
                movie.genres && movie.genres.length > 0 &&
                    React.createElement("p", null,
                        React.createElement("strong", null, "Sjanger:"),
                        "\u00A0",
                        movie.genres),
                movie.ageLimit &&
                    React.createElement("p", null,
                        React.createElement("strong", null, "Aldersgrense:"),
                        "\u00A0",
                        movie.ageLimit),
                movie.originalLanguage &&
                    React.createElement("p", null,
                        React.createElement("strong", null, "Originalspr\u00E5k:"),
                        "\u00A0",
                        movie.originalLanguage),
                movie.director &&
                    React.createElement("p", null,
                        React.createElement("strong", null, "Regiss\u00F8r:"),
                        "\u00A0",
                        movie.director))),
            React.createElement("div", null,
                movie.summary &&
                    React.createElement("div", { className: "movie-summary" },
                        React.createElement("p", null, movie.summary)),
                movie.description &&
                    React.createElement("div", { className: "movie-description" }, movie.object === 'culture'
                        ? React.createElement("div", { dangerouslySetInnerHTML: this.createMarkup(movie.description) })
                        : React.createElement("p", null, movie.description)))));
    }
}
exports.MovieInfo = MovieInfo;
exports.default = MovieInfo;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-movie-info/MovieInfo.tsx